{
  "avalancheSize.label": "Lawinengröße",
  "avalancheSize.small": "klein",
  "avalancheSize.medium": "mittel",
  "avalancheSize.large": "groß",
  "avalancheSize.very_large": "sehr groß",
  "avalancheSize.extreme": "extrem",
  "snowpackStability.label": "Schneedeckenstabilität",
  "snowpackStability.good": "gut",
  "snowpackStability.fair": "mittel",
  "snowpackStability.poor": "schlecht",
  "snowpackStability.very_poor": "sehr schlecht",
  "frequency.label": "Gefahrenstellen",
  "frequency.none": "keine",
  "frequency.few": "wenige",
  "frequency.some": "einige",
  "frequency.many": "viele",
  "dangerRating.label": "Gefahrenstufe",
  "dangerRating.missing": "fehlt",
  "dangerRating.missing.long": "Fehlt",
  "dangerRating.no_snow": "kein Schnee",
  "dangerRating.no_snow.long": "Kein Schnee",
  "dangerRating.no_rating": "keine Beurteilung",
  "dangerRating.no_rating.long": "Keine Beurteilung",
  "dangerRating.low": "gering",
  "dangerRating.low.long": "Gefahrenstufe 1 — Gering",
  "dangerRating.low.speech": "geringe Lawinengefahr, also Gefahrenstufe eins",
  "dangerRating.moderate": "mäßig",
  "dangerRating.moderate.long": "Gefahrenstufe 2 — Mäßig",
  "dangerRating.moderate.speech": "mäßige Lawinengefahr, also Gefahrenstufe zwei",
  "dangerRating.considerable": "erheblich",
  "dangerRating.considerable.long": "Gefahrenstufe 3 — Erheblich",
  "dangerRating.considerable.speech": "erhebliche Lawinengefahr, also Gefahrenstufe drei",
  "dangerRating.high": "groß",
  "dangerRating.high.long": "Gefahrenstufe 4 — Groß",
  "dangerRating.high.speech": "große Lawinengefahr, also Gefahrenstufe vier",
  "dangerRating.very_high": "sehr groß",
  "dangerRating.very_high.long": "Gefahrenstufe 5 — Sehr Groß",
  "dangerRating.very_high.speech": "sehr große Lawinengefahr, also Gefahrenstufe fünf",
  "avalancheType.label": "Lawinenart",
  "avalancheType.slab": "Schneebrettlawine",
  "avalancheType.loose": "Lockerschneelawine",
  "avalancheType.glide": "Gleitschneelawine",
  "avalancheProblem.label": "Lawinenproblem",
  "avalancheProblem.coreZones.label": "Avalanche Problems with Core Zones",
  "avalancheProblem.new_snow": "Neuschnee",
  "avalancheProblem.wind_slab": "Triebschnee",
  "avalancheProblem.persistent_weak_layers": "Altschnee",
  "avalancheProblem.wet_snow": "Nassschnee",
  "avalancheProblem.gliding_snow": "Gleitschnee",
  "avalancheProblem.favourable_situation": "Günstige Situation",
  "avalancheProblem.cornices": "Wechten",
  "avalancheProblem.no_distinct_avalanche_problem": "Kein ausgeprägtes Lawinenproblem",
  "avalancheProblem.new_snow.speech": "ein Neuschnee-Problem",
  "avalancheProblem.wind_slab.speech": "ein Triebschnee-Problem",
  "avalancheProblem.persistent_weak_layers.speech": "ein Altschnee-Problem",
  "avalancheProblem.wet_snow.speech": "ein Nassschnee-Problem",
  "avalancheProblem.gliding_snow.speech": "ein Gleitschnee-Problem",
  "avalancheProblem.favourable_situation.speech": "eine günstige Situation",
  "avalancheProblem.cornices.speech": "ein Wechten-Problem",
  "avalancheProblem.no_distinct_avalanche_problem.speech": "kein ausgeprägtes Lawinenproblem",
  "dangerPattern.label": "Gefahrenmuster",
  "dangerPattern.dp1": "gm.1: bodennahe schwachschicht",
  "dangerPattern.dp2": "gm.2: gleitschnee",
  "dangerPattern.dp3": "gm.3: regen auf schnee",
  "dangerPattern.dp4": "gm.4: kalt auf warm / warm auf kalt",
  "dangerPattern.dp5": "gm.5: schnee nach langer kälteperiode",
  "dangerPattern.dp6": "gm.6: lockerer schnee und wind",
  "dangerPattern.dp7": "gm.7: schneearm neben schneereich",
  "dangerPattern.dp8": "gm.8: eingeschneiter oberflächenreif",
  "dangerPattern.dp9": "gm.9: eingeschneiter graupel",
  "dangerPattern.dp10": "gm.10: frühjahrssituation",
  "aspect.N": "Nord",
  "aspect.NE": "Nord-Ost",
  "aspect.E": "Ost",
  "aspect.SE": "Süd-Ost",
  "aspect.S": "Süd",
  "aspect.SW": "Süd-West",
  "aspect.W": "West",
  "aspect.NW": "Nord-West",
  "tendency.label": "Tendenz",
  "tendency.progression.label": "Development of avalanche danger",
  "tendency.decreasing": "Tendenz: Lawinengefahr nimmt ab",
  "tendency.steady": "Tendenz: Lawinengefahr bleibt gleich",
  "tendency.increasing": "Tendenz: Lawinengefahr steigt",
  "validTimePeriod.all_day": "Den ganzen Tag",
  "validTimePeriod.all_day.long": "Den ganzen Tag",
  "validTimePeriod.earlier": "früher",
  "validTimePeriod.earlier.long": "Früher am Tag",
  "validTimePeriod.later": "später",
  "validTimePeriod.later.long": "Später am Tag",
  "elevation.treeline.capitalized": "Waldgrenze",
  "elevation.treeline": "Waldgrenze",
  "elevation.all": "Alle Höhenlagen",
  "elevation.below": "Unter {0}",
  "elevation.above": "Über {0}",
  "elevation.band": "Zwischen {0} und {1}",
  "synopsis.label": "Wetter",
  "snowpack.label": "Schneedecke",
  "travelAdvisory.label": "Travel Advisory",
  "forecast.label": "Lawinenvorhersage"
}
